'use client';

import { ConsentProvider } from 'cookiebanner-finally';

import { ReactNode } from 'react';

export function CookieProvider({ children }: { children: ReactNode }) {
  return <ConsentProvider>{children}</ConsentProvider>;
}
